import { Pipe, PipeTransform } from '@angular/core';
import { MetaService } from '@bo-client/core/api/meta-service';

@Pipe({
  name: 'offerState'
})
export class OfferStatePipe implements PipeTransform {
  constructor(private metaService: MetaService) {}
  transform(value: string, args?: 'displayName' | 'cssColor'): string {
    if (!value) return '';
    const state = this.metaService.getOrderRequestStateValues().find((state) => state.value === value);
    if (!state) return value;
    return args === 'cssColor' ? state.cssColor || '#71dde3' : state.displayName;
  }
}
